import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import { Pagination } from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ConfirmDeleteDialog, InfoDialog, Loader, ScrollToTop, SearchBar } from "../../../components";
import { ShowTableValidasiDataVerifikator } from "../../../components/ShowTable";

const TampilValidasiDataVerifikator = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [isValidasiDataVerifikatorExist, setIsValidasiDataVerifikatorExist] = useState(false);
  const [dataVerifikasi, setDataVerifikasi] = useState(null);
  const [statusValid, setStatusValid] = useState("");
  const [validasiDataVerifikatorsData, setValidasiDataVerifikatorsData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  let [page, setPage] = useState(0);
  const [limit] = useState(20);
  const [pages, setPages] = useState(0);
  const [query, setQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    id ? getValidasiDataVerifikatorById() : setIsValidasiDataVerifikatorExist(false);
  }, [id]);

  useEffect(() => {
    getValidasiDataVerifikators();
  }, [page, searchTerm]);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  const getValidasiDataVerifikators = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/validasiDataVerifikatorsPagination?search_query=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQuery(searchTerm);
      setValidasiDataVerifikatorsData(response.data.validasiDataVerifikators);
      setPage(response.data.page);
      setPages(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data Validasi Data Verifikator.");
    }
    setLoading(false);
  };

  const getValidasiDataVerifikatorById = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/validasiDataVerifikators/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsValidasiDataVerifikatorExist(true);
      setDataVerifikasi(response.data.dataVerifikasi);
      setStatusValid(response.data.statusValid);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil detail Validasi Data Verifikator.");
    }
    setLoading(false);
  };

  const deleteValidasiDataVerifikator = async () => {
    setShowDeleteConfirm(false);
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteValidasiDataVerifikator/${id}`, {
        id: user._id,
        token: user.token,
      });
      navigate("/validasiDataVerifikator");
      await getValidasiDataVerifikators();
    } catch (err) {
      handleAuthError(err);
      setDeleteError(err.response?.data?.message || "Gagal menghapus Validasi Data Verifikator.");
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Validasi Data Verifikator</h1>
        </div>
        <Button className="btn-icon" size="sm" onClick={() => navigate("/validasiDataVerifikator/tambahValidasiDataVerifikator")}>
          <MdAdd /> Tambah
        </Button>
      </div>
      {error && <Alert variant="warning">{error}</Alert>}

      {isValidasiDataVerifikatorExist && (
        <section className="section-panel">
          <div className="toolbar mt-0">
            <div className="detail-title-actions">
              <Button className="btn-back" size="sm" variant="outline-secondary" onClick={() => navigate("/validasiDataVerifikator")}>
                {"< Kembali"}
              </Button>
              <div>
                <h2 className="h6 fw-bold mb-1">Detail Validasi Data Verifikator</h2>
                <div className="text-muted">{dataVerifikasi?.admin?.namaPemohon?.permohonan?.namaPemohon}</div>
              </div>
            </div>
            <div className="d-flex gap-2 flex-wrap">
              <Button className="btn-icon" size="sm" variant="outline-primary" onClick={() => navigate(`/validasiDataVerifikator/${id}/edit`)}>
                <MdEdit /> Ubah
              </Button>
              <Button className="btn-icon" size="sm" variant="outline-danger" onClick={() => setShowDeleteConfirm(true)}>
                <MdDelete /> Hapus
              </Button>
            </div>
          </div>
          <hr />
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <div className="detail-label">Nama Pemohon</div>
                <div className="detail-value">{dataVerifikasi?.admin?.namaPemohon?.permohonan?.namaPemohon || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">No Jual</div>
                <div className="detail-value">{dataVerifikasi?.admin?.noJual || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Nopol</div>
                <div className="detail-value">{dataVerifikasi?.admin?.nopol || "-"}</div>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <div className="detail-label">Alasan Data Verifikasi</div>
                <div className="detail-value">{dataVerifikasi?.alasan || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Status Valid</div>
                <div className="detail-value">{statusValid || "-"}</div>
              </div>
            </Col>
          </Row>
        </section>
      )}

      <Form onSubmit={searchData}>
        <div className="search-row">
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button type="submit">Cari</Button>
        </div>
      </Form>
      <ShowTableValidasiDataVerifikator currentPosts={validasiDataVerifikatorsData} />
      <div className="search-row">
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </div>
      <ConfirmDeleteDialog
        show={showDeleteConfirm}
        message={`Yakin ingin menghapus Validasi Data Verifikator ${dataVerifikasi?.admin?.namaPemohon?.permohonan?.namaPemohon}?`}
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={deleteValidasiDataVerifikator}
      />
      <InfoDialog
        show={Boolean(deleteError)}
        title="Data Tidak Bisa Dihapus"
        message={deleteError}
        onClose={() => setDeleteError("")}
      />
    </div>
  );
};

export default TampilValidasiDataVerifikator;

